import { render, staticRenderFns } from "./FuncionariosLista.vue?vue&type=template&id=2b40dfea&scoped=true&"
import script from "./FuncionariosLista.vue?vue&type=script&lang=js&"
export * from "./FuncionariosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40dfea",
  null
  
)

export default component.exports